import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SearchBranch } from '../../../external/AggregationApi';
import { actions } from '../../modules/Actions';

export const initialSearchBranchPeriodState: { [key: string]: SearchBranch } = {};

export const searchBranchPeriodReducer = reducerWithInitialState(initialSearchBranchPeriodState).case(
  actions.updateSearchBranch.period,
  (state: { [key: string]: SearchBranch }, payload: { [key: string]: SearchBranch }) => {
    return {
      ...state,
      ...payload,
    };
  }
);
